import React, { useRef, useState } from 'react';
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { Paperclip } from "lucide-react";

const UploadAttachment = ({ onFileChange }) => {

    const [mediaFile, setMediaFile] = useState(null);
    const [mediaType, setMediaType] = useState('');
    const [isMediaSelected, setIsMediaSelected] = useState(false);

    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            let mediaType = 'other'
            setMediaFile(file);
            setIsMediaSelected(true);

            // Determine media type based on file type
            if (file.type.startsWith('video')) {
                mediaType = 'video'
            } else if (file.type.startsWith('image')) {
                mediaType = 'image'
            } else if (file.type.startsWith('audio')) {
                mediaType = 'audio'
            }
            setMediaType(mediaType);
            onFileChange(file, mediaType);
        }
    };

    const clearAttachment = () => {
        setMediaFile(null);
        setIsMediaSelected(false);
        setMediaType('');
    }

    return (
        <>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon"
                        className="h-8 w-8"
                        onClick={() => fileInputRef.current.click()}
                    >
                        <Paperclip className={cn(
                            "h-4 w-4 transition-colors",
                            isMediaSelected 
                                ? "text-green-500" 
                                : "text-muted-foreground hover:text-foreground"
                        )} />
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    {isMediaSelected ? "File attached - click to change" : "Attach file"}
                </TooltipContent>
            </Tooltip>
            <input
                type="file"
                accept="*"
                capture="camera microphone"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
        </>
    );
};

export default UploadAttachment;
